import type { CompletionState } from '../../game/events';

function resultText(result: CompletionState): string {
  const seconds = Math.floor(result.elapsedMs / 1000);
  const time = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
  return `I cleared ${result.levelName} as ${result.characterName} for ${result.score.total.toLocaleString()} pts (${time}). Mission total ${result.missionScore.toLocaleString()} · ${result.stagesCleared}/10. Beat my Project Roach run!`;
}

function challengeUrl(result: CompletionState): string {
  const url = new URL(window.location.href);
  url.search = '';
  url.searchParams.set('challenge', `${result.characterId}.${result.missionScore || result.score.total}`);
  return url.toString();
}

async function makePoster(result: CompletionState): Promise<Blob> {
  const canvas = document.createElement('canvas');
  canvas.width = 1200;
  canvas.height = 630;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Share canvas is unavailable.');
  context.fillStyle = '#151511';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = '#a9ff3f';
  context.fillRect(0, 0, 34, canvas.height);
  context.fillStyle = '#f0e5c8';
  context.font = '900 42px Arial';
  context.fillText('PROJECT ROACH / FICTIONAL CIVIC SATIRE', 84, 82);
  context.font = '900 110px Arial';
  context.fillText('MIC SAFE.', 78, 245);
  context.fillText('ROACH OUT.', 78, 350);
  context.fillStyle = '#ff5a54';
  context.font = '900 74px Arial';
  context.fillText(result.score.total.toLocaleString(), 80, 460);
  context.fillStyle = '#a9ff3f';
  context.font = '900 28px Arial';
  context.fillText(`MISSION ${result.missionScore.toLocaleString()} · ${result.stagesCleared}/10`, 82, 505);
  context.fillStyle = '#f0e5c8';
  context.font = '700 32px Arial';
  context.fillText(`${result.characterName.toUpperCase()}  •  ${Math.floor(result.elapsedMs / 1000)} SECONDS  •  ${result.tokens} TOKENS`, 82, 555);
  context.strokeStyle = '#a9ff3f';
  context.lineWidth = 14;
  context.beginPath();
  context.ellipse(1030, 320, 92, 150, -0.2, 0, Math.PI * 2);
  context.stroke();
  return await new Promise<Blob>((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Could not create poster.')), 'image/png'));
}

export async function shareResult(result: CompletionState): Promise<string> {
  const text = resultText(result);
  const url = challengeUrl(result);
  const blob = await makePoster(result);
  const file = new File([blob], 'project-roach-result.png', { type: 'image/png' });
  if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
    await navigator.share({ title: 'Project Roach result', text, url, files: [file] });
    return 'Result shared.';
  }
  const anchor = document.createElement('a');
  anchor.href = URL.createObjectURL(blob);
  anchor.download = file.name;
  anchor.click();
  URL.revokeObjectURL(anchor.href);
  await navigator.clipboard?.writeText(`${text} ${url}`);
  return 'Poster downloaded and challenge text copied.';
}
